jQuery($ => {
	// region VARIABLES

	// Posts
	const posts = $('.block_posts').map((index, element) => ({
		this: $(element),
		params: $(element).data()
	}));

	// endregion VARIABLES

	// region INITIALIZATION

	Init();

	function Init()
	{
		// Setup posts
		posts.each((index, container) => {
			SetupPost(container);
		});
	}

	function SetupPost(container)
	{
		// Switch layout parameters, and handle posts accordingly
		switch(container.params.layout)
		{
			case 'slideshow':
				SetupSlideshow(container);
				break;
		}
	}

	// endregion INITIALIZATION

	// region SLIDESHOW

	function SetupSlideshow(container)
	{
		// Initialize Slick
		container.this.slick({
			// TODO: Add parameters from Block params?
			speed: 300,
			infinite: true,
			autoplay: false,
			adaptiveHeight: true,
			arrows: true,
			dots: false,
			prevArrow: `<button class='slick-prev ${glob.slug}_chevron-left' type='button' aria-label='Previous'></button>`,
			nextArrow: `<button class='slick-next ${glob.slug}_chevron-right' type='button' aria-label='Next'></button>`
		});
	}

	// endregion SLIDESHOW
})